// AgentDashboardPlaceholder — single shared body for any agent without a real
// dashboard yet. Used by AgentViewScreen's Dashboard tab whenever agent !== 'arthur'
// (Arthur is the only agent with a real Dashboard tab — his existing TradingPage
// is mounted inline; every other agent shows this placeholder until their own
// dashboard ships).
//
// ── THE RUN CONTROL WAS MOUNTED HERE FOR ONE ROUND, AND MOVED UP ───────────
// It went to `AgentTabBar` (owner ruling 2026-08-31 — the header bar that
// already carries DASHBOARD and CHAT). That bar sits ABOVE both tabs, so the
// control is now on this screen anyway AND on the chat, from one mount instead
// of two. This file went back to what it was.

import React from 'react';
import { REXY_FONT, REXY_CONSOLE } from '../../../lib/rexyConsole';

export interface AgentDashboardPlaceholderProps {
  agent: string; // lowercase id
  domain: string;
}

export default function AgentDashboardPlaceholder({ agent, domain }: AgentDashboardPlaceholderProps) {
  return (
    <div style={bodyStyle}>
      <div style={titleStyle}>{agent.toUpperCase()}</div>
      <div style={subtleStyle}>{domain} · DASHBOARD COMING SOON</div>
    </div>
  );
}

const bodyStyle: React.CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  padding: 24,
  fontFamily: REXY_FONT,
};

const titleStyle: React.CSSProperties = {
  fontSize: 18,
  fontWeight: 700,
  letterSpacing: 4,
  color: '#ffffff',
};

const subtleStyle: React.CSSProperties = {
  fontSize: 10,
  letterSpacing: 2,
  color: REXY_CONSOLE.dimText,
};
